import type {RelationshipConstraint} from '@packages/systems/constraints-types';
import {SHARED_FORM_WRAPPER_CONSTRAINTS_DESCENDANTS} from './formConstraints';

export const SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS: RelationshipConstraint[] =
  [
    // All atoms that render anchor tags.
    {is: 'TabsLink', rule: 'Forbid'},
    {is: 'Link', rule: 'Forbid'},
    {is: 'LightboxWrapper', rule: 'Forbid'},
    {is: 'CommerceCartOpenLink', rule: 'Forbid'},
    {is: 'CommerceCartCloseLink', rule: 'Forbid'},
    {is: 'CommerceCartRemoveLink', rule: 'Forbid'},
    {is: 'CommerceCartCheckoutButton', rule: 'Forbid'},
    {is: 'CommerceCartQuickCheckoutButton', rule: 'Forbid'},
    {is: 'CommerceCheckoutPlaceOrderButton', rule: 'Forbid'},
    {is: 'CommerceCartApplePayButton', rule: 'Forbid'},
    {is: 'PaginationPrevious', rule: 'Forbid'},
    {is: 'PaginationNext', rule: 'Forbid'},
    {is: 'NavbarLink', rule: 'Forbid'},
    {is: 'NavbarBrand', rule: 'Forbid'},
    {is: 'DropdownLink', rule: 'Forbid'},

    // Rest of atoms that we don't allow inside anchor tags.
    {is: 'DynamoWrapper', rule: 'Forbid'},
    {is: 'RichText', rule: 'Forbid'},
    {is: 'Video', rule: 'Forbid'},

    ...SHARED_FORM_WRAPPER_CONSTRAINTS_DESCENDANTS,
  ];
